var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_41279",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9226 25.0718L31.2997 25.1572C37.5454 26.6084 41.8294 29.4343 41.995 33.1751L42 33.4007L41.9954 33.6176C41.7688 38.9421 33.2021 42.4147 22.5063 42.7136L22.0595 42.7243L21.7104 42.7296L20.9995 42.7339L20.5625 42.7321C9.3742 42.6427 0.236984 39.1178 0.00453572 33.616L0 33.4007L0.00497549 33.1751C0.170472 29.4358 4.45018 26.6106 10.6917 25.1589L11.0763 25.0718L11.4214 25.617L11.7737 26.1665L12.1331 26.7196L12.3207 27.0064L12.51 27.2924L12.1336 27.3767C6.40263 28.6939 2.50177 31.1233 2.33837 33.2616L2.33304 33.4007L2.33809 33.5359C2.56679 36.6098 10.528 40.2908 20.5494 40.3984L20.9995 40.4009L21.443 40.3985C31.4675 40.2924 39.4321 36.6105 39.6608 33.5359L39.6659 33.4007L39.6606 33.2616C39.4972 31.1243 35.6 28.6962 29.8724 27.3776L29.4879 27.2913L29.8659 26.7196L30.3233 26.015L30.7695 25.317L30.9226 25.0718ZM20.9995 0.733887L21.2943 0.737939C27.0724 0.896945 31.7282 5.71563 31.8843 11.6958L31.8884 12.0061L31.8833 12.2434C31.6212 18.5089 21.2633 32.2152 21.0044 32.5569L20.9995 32.5634C20.7289 32.2064 10.1105 18.1544 10.1105 12.0061C10.1105 5.78112 14.9854 0.733887 20.9995 0.733887ZM20.9995 7.43534L20.784 7.44079C18.5714 7.55294 16.812 9.38239 16.812 11.6228C16.812 13.8632 18.5714 15.6927 20.784 15.8048L20.9995 15.8103L21.215 15.8048C23.3562 15.6963 25.074 13.9795 25.1826 11.8383L25.188 11.6228L25.1826 11.4073C25.0703 9.19478 23.2399 7.43534 20.9995 7.43534Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_41279)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.88879 46.6226H45.8887V-3.15491H-3.88879V46.6226Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.77747 50.5114H49.7775V-7.04358H-7.77747V50.5114Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.3356debbe5e3851c992d8498fe132f2e.svg";
export { ForwardRef as ReactComponent };